module.exports = __webpack_public_path__ + "img/banco-promerica-logo.7fc3afe4.png";